var $ = jQuery.noConflict();
var sending = false;
var showMobileMenu = false;
var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

function getParameterByName(name, url) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results){
    return null;
  }
  if (!results[2]){
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

$(function() {
  if(isSafari){
    $('body').addClass('safariBrowser');
  }
  if(isFirefox){
    $('body').addClass('firefoxBrowser');
  }

  $.fn.serializeObject = function(){
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || '');
      } else {
        o[this.name] = this.value || '';
      }
    });
    return o;
  };

  $('#mob').on('click', function() {
    var mm = $('.mobileMenu');
    if(mm.hasClass('hide')){
      mm.removeClass('hide');
    }else{
      mm.addClass('hide');
    }
  });
});

//Reset menu's if width changes
var defaultWidth = $(window).width();

setInterval(function() {
  defaultWidth = $(window).width();
}, 500);

$(window).resize(function() {
  if(defaultWidth !== $(window).width()){
    //console.log('do reset');
    $('.mobileMenu').addClass("hide");
  }
});

$(window).scroll(function(){

//  if($(window).width() > 500) {
    // if ($(window).scrollTop() >= 54) {
    //   $('#topOverlay').addClass('sticky');
    //   $('#stickySpace').show();
    // }else {
    //   $('#topOverlay').removeClass('sticky');
    //   $('#stickySpace').hide();
    // }
  //}
  
});
